import { getClassName } from '@perpay-web/utils/domUtils';

import styles from './Skeleton.scss';

/**
 * Skeleton component used as a placeholder during content loading.
 */
const Skeleton = ({ className = '', ref }) => (
    <div ref={ref} className={getClassName(styles.skeleton, className)} />
);

export default Skeleton;
